import React from 'react';
import './LegalNotice.css';

// Единый источник правовых оговорок. Меняем текст здесь — он обновляется
// во всех местах сайта, где выводится дисклеймер.
export const SERVICES_DISCLAIMER =
  'Оказываем услуги по технической подготовке документов. Не предоставляем юридические ' +
  'консультации, не являемся юридической фирмой, не представляем интересы клиентов в ' +
  'госорганах. Услуги не являются адвокатской деятельностью. Результат оказания услуг ' +
  'не гарантирует получение миграционного статуса — решение принимает уполномоченный ' +
  'государственный орган. Сроки ответа зависят от загруженности менеджеров.';

export const CONSULTATION_DISCLAIMER =
  'Консультации носят информационный характер и не являются юридической консультацией.';

const TEXTS = {
  services: SERVICES_DISCLAIMER,
  consultation: CONSULTATION_DISCLAIMER,
};

const LegalNotice = ({ variant = 'services', className = '' }) => (
  <p className={`legal-notice ${className}`.trim()}>
    {TEXTS[variant] || TEXTS.services}
  </p>
);

export default LegalNotice;
